// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__20ThM","approved":"Status_approved__37Bik","rejected":"Status_rejected__2cwte","expired":"Status_expired__v79Qg","label":"Status_label__2Fxqf"};